module.exports = __webpack_public_path__ + "img/V14.56f122eb.jpg";